import { render, staticRenderFns } from "./PushNotificationsItem.vue?vue&type=template&id=a0c748be&scoped=true"
import script from "./PushNotificationsItem.vue?vue&type=script&lang=js"
export * from "./PushNotificationsItem.vue?vue&type=script&lang=js"
import style0 from "./PushNotificationsItem.vue?vue&type=style&index=0&id=a0c748be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c748be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0c748be')) {
      api.createRecord('a0c748be', component.options)
    } else {
      api.reload('a0c748be', component.options)
    }
    module.hot.accept("./PushNotificationsItem.vue?vue&type=template&id=a0c748be&scoped=true", function () {
      api.rerender('a0c748be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PushNotificationsItem.vue"
export default component.exports